import API from './api';

export default class Company extends API { }
